export const searchConfig = function (type, shopList, tagList, categoryList, supplierList) {
  let searchConfigs = [
    {
      key: ['filterObj', 'target'],
      searchType: 'selectInput',
      componentData: {
        dictKey: 'accountId',
        defaultValue: ['spuId', ''],
        options: [
          { label: window.$t('stores::products-info::spu'), value: 'spuId' },
          { label: window.$t('stores::products-info::sku'), value: 'skuId' },
          { label: window.$t('stores::products-info::name'), value: 'spuTitle' },
          { label: window.$t('stores::products-info::buyer'), value: 'buyer' },
        ],
      },
    },
    {
      label: window.$t('system::responsible::供应商'),
      key: 'supplier_id',
      searchType: 'select',
      componentData: {
        dictKey: 'supplier_id',
        placeholder: window.$t('stores::products-info::select_supplier'),
        clearable: true,
        options: supplierList,
      },
    },
    {
      label: window.$t('stores::products-info::category'),
      key: 'category_ids',
      searchType: 'cascader',
      componentData: {
        dictKey: 'category_ids',
        placeholder: window.$t('stores::products-info::select_category'),
        clearable: true,
        options: categoryList,
        props: { label: 'name', value: 'id', children: 'childrens', checkStrictly: true }
      },
    },
    // {
    //   label: window.$t('stores::products-info::spu_price'),
    //   key: 'is_spu_priced',
    //   searchType: 'select',
    //   componentData: {
    //     dictKey: 'is_spu_priced',
    //     placeholder: window.$t('stores::products-info::select_spu_price'),
    //     clearable: true,
    //     options: [
    //       { label: window.$t('stores::products-info::yes'), value: true },
    //       { label: window.$t('stores::products-info::no'), value: false },
    //     ],
    //   },
    // },
    {
      label: window.$t('stores::products-info::goods_tag'),
      key: 'tags',
      searchType: 'select',
      componentData: {
        dictKey: 'tags',
        placeholder: window.$t('stores::products-info::select_tag'),
        clearable: true,
        multiple: true,
        collapseTags: true,
        options: tagList,
      },
    },
    {
      label: window.$t('stores::products-info::creatr_time'),
      key: 'time',
      searchType: 'selectDatepicker',
      componentData: {
        options: [
          { keys: ['create_time_begin', 'create_time_end'] },
        ],
        dateComponentData: {
          startPlaceholder: window.$t('stores::products-info::start_time'),
          endPlaceholder: window.$t('stores::products-info::end_time')
        },
        clearable: true,
      },
    },
    {
      label: window.$t('stores::products-info::store'),
      key: 'shop_id',
      searchType: 'select',
      componentData: {
        dictKey: 'shop_id',
        placeholder: window.$t('stores::products-info::select_store'),
        options: shopList,
        clearable: true,
      }
    }
  ]
  return searchConfigs;
}

export const tagConfig = {
  UN_PUBLISHED: 'UN_PUBLISHED',
  PUBLISHED: 'PUBLISHED',
}

export const tableColumns = [
  // {
  //   type: 'selection',
  //   fixed: true,
  //   selectable: (row) => {
  //     return !!row.spuId
  //   },
  //   'label-class-name': 'table-selection'
  // },
  {
    prop: 'expand',
    fixed: true,
    minWidth: 85
  },
  // {
  //   label: 'SPU',
  //   fixed: true,
  //   prop: 'spu',
  //   minWidth: 100
  // },
  {
    label: window.$t('stores::products-info::goods_info'),
    prop: 'title',
    showOverflowTooltip: true,
    tooltipRowKey: 'title',
    minWidth: 300
  },
  {
    label: window.$t('stores::products-info::category'),
    prop: 'categoryNames',
    minWidth: 150
  },
  {
    label: window.$t('system::responsible::供应商'),
    prop: 'supplier',
    minWidth: 150
  },
  {
    label: window.$t('stores::products-info::purchase_price') + '($)',
    prop: 'purchasePrice',
    minWidth: 150
  },
  {
    label: window.$t('stores::products-info::compare_at_price') + '($)',
    prop: 'compareAtPrice',
    minWidth: 130
  },
  {
    label: window.$t('stores::products-info::sale_price') + '($)',
    prop: 'salePrice',
    minWidth: 130
  },
  {
    label: window.$t('stores::products-info::buyer'),
    prop: 'buyer',
    minWidth: 130,
    formatter(row) {
      return row.buyer || '--'
    }
  },
  {
    label: window.$t('stores::products-info::goods_stock'),
    prop: 'store',
    minWidth: 150
  },
  {
    label: window.$t('stores::products-info::status'),
    prop: 'status',
    minWidth: '100'
  },
  {
    label: window.$t('stores::products-info::operate'),
    prop: 'opt',
    fixed: 'right',
    minWidth: 100
  }
]

function loadProdTag(node, resolve) {
  let id = 0;
  const { level } = node;
  setTimeout(() => {
    const nodes = Array.from({ length: level + 1 })
      .map(item => ({
        value: ++id,
        label: `选项${id}`,
        leaf: level >= 2
      }));
    // 通过调用resolve将子节点数据返回，通知组件数据加载完成
    resolve(nodes);
  }, 1000);
}
